import DialogActions from '@material-ui/core/DialogActions';
import ActionModal from 'components/common/ActionModal/ActionModal';
import { Button, BUTTON } from '../../../../components/common/Button/Button';
import styles from './ExitModal.scss';

const { BGCOLOR, COLOR, OUTCOLOR } = BUTTON;

export const ExitModal = ({
    isOpen, 
    onClose,
    onSave,
    onDiscard
}) => {

    return <ActionModal
        isOpen={isOpen}
        onClose={onClose}
        onSave={onSave}
        title='Exit Draft'
        CustomModalFooter={<ExitModalButtons onDiscard={onDiscard} onSave={onSave} onClose={onClose}/>}
    >
        <ExitModalHelperText />
    </ActionModal>;
};

const ExitModalHelperText = () => 'Do you want to save the changes made to your study before exiting?';

const ExitModalButtons = ({ onClose, onSave, onDiscard }) => {
    return (
        <DialogActions className={styles.exitModalBtn} data-cy="ExitModal">
            <Button
                onClick={onDiscard}
                bgcolor={BGCOLOR.RED}
                color={COLOR.WHITE}
                data-cy="ExitModal-Discard"
            >
                Discard Changes
            </Button>
            <div className={styles.btnRight} data-cy="ExitModal-BtnBlock">
                <Button
                    outline={OUTCOLOR.LIGHTGREY}
                    onClick={onClose}
                    bgcolor={BGCOLOR.CLEAR}
                    color={COLOR.GREY}
                    data-cy="ExitModal-Close"
                >
                Close
                </Button>
                <Button
                    onClick={onSave}
                    bgcolor={BGCOLOR.ORANGE}
                    color={COLOR.WHITE}
                    data-cy="ExitModal-Save"
                >
                Save Changes
                </Button>
            </div>
        </DialogActions>
    );
};